import { extendTheme } from "@chakra-ui/react";
import { cardAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";
import { mode } from "@chakra-ui/theme-tools";

const { definePartsStyle } =
  createMultiStyleConfigHelpers(cardAnatomy.keys);

const variants = {
  selected: (props) => definePartsStyle({
    container: {
      border: "3px solid", 
      borderColor: "bag.fill",
      boxShadow: mode("0px 0px 20px rgba(186, 1, 34, 0.2)", "0px 0px 20px rgba(232, 16, 62, 0.4)")(props), 
      transform: "scale(1.02)",
      zIndex: 10,
      bg: "card.bg",
      color: "hero.text",
    },
  }),
  elevated: (props) => definePartsStyle({
    container: {
      border: "1px solid",
      borderColor: "card.border",
      bg: "card.bg",
      color: "hero.text",
      boxShadow: "card.shadow",
    },
  }),
};

const config = {
  initialColorMode: 'light',
  useSystemColorMode: false,
};

const customTheme = extendTheme({
  config,
  semanticTokens: {
    colors: {
      'bag.fill': { default: '#BA0122', _dark: '#E8103E' }, // More luminous red for dark mode
      'bag.bg': { default: 'gray.100', _dark: 'whiteAlpha.200' },
      'bag.tick': { default: '#051D42', _dark: 'whiteAlpha.600' },
      'bag.label': { default: '#051D42', _dark: 'whiteAlpha.800' },
      'hero.text': { default: 'brand.navy', _dark: 'white' },
      'hero.subtext': { default: 'gray.500', _dark: 'whiteAlpha.600' },
      'card.bg': { default: 'white', _dark: 'brand.charcoal' },
      'card.border': { default: 'gray.200', _dark: 'whiteAlpha.200' },
      'card.shadow': { 
        default: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)', 
        _dark: '0 20px 25px -5px rgba(0, 0, 0, 0.3), 0 10px 10px -5px rgba(0, 0, 0, 0.04)' 
      },
      'board.bg': { default: 'gray.50', _dark: 'brand.charcoal' },
      'board.accent': { default: 'brand.navy', _dark: 'brand.navyDark' },
      'header.bg': { default: 'brand.navy', _dark: 'brand.navyDark' },
      'bottomNav.bg': { default: 'brand.navy', _dark: 'brand.navyDark' },
      'pbp.header.bg': { default: 'gray.100', _dark: 'whiteAlpha.100' },
      'pbp.header.text': { default: 'brand.navy', _dark: 'white' },
      'pbp.panel.bg': { default: 'white', _dark: 'brand.charcoal' },
      'pbp.panel.text': { default: 'brand.navy', _dark: 'whiteAlpha.900' },
      'pbp.item.hover': { default: 'gray.50', _dark: 'whiteAlpha.50' },
      'pbp.advisory.bg': { default: 'gray.50', _dark: 'whiteAlpha.100' },
      'chart.grid': { default: 'gray.100', _dark: 'whiteAlpha.100' },
      'chart.label': { default: 'gray.400', _dark: 'whiteAlpha.600' },
    },
  },
  colors: {
    brand: {
      navy: "#051D42",
      navyDark: "#000414", 
      red: "#BA0122",
      blue: "#0236AE",
      vibrantBlue: "#005CFF", // More poppy blue for dark mode
      white: "#FBFFFF",
      sand: "#E2D9CC",
      black: "#000000", 
      charcoal: "#1A1C1E",
      glass: "rgba(5, 29, 66, 0.85)", 
    },
  },
  shadows: {
    broadcast: "0px 24px 24px rgba(5, 29, 66, 0.12)",
  },
  fonts: {
    heading: "'HEX Franklin MLB', sans-serif",
    body: "'HEX Franklin MLB', sans-serif",
  },
  styles: {
    global: (props) => ({
      body: {
        bg: mode("brand.white", "brand.navyDark")(props),
        color: mode("brand.navy", "white")(props),
      },
    }),
  },
  components: {
    Card: {
      variants,
    },
    Button: {
      baseStyle: {
        borderRadius: "none", 
      },
      variants: {
        solid: (props) => ({
          bg: mode("brand.navy", "brand.blue")(props),
          color: "white",
          _hover: {
            bg: mode("brand.blue", "#1a4dc9")(props),
          },
        }),
        action: {
          bg: "brand.red",
          color: "white",
          _hover: {
            bg: "#930018",
          },
        },
      },
    },
  },
});

export default customTheme;